import angular from 'angular';

export const RailComponent = {
  selector: 'abRail',
  restrict: 'E',
  bindings: {
    items: '<',
    mainItem: '<?',
  },
  template: /* html */ `
  <div class="nav-rail">
    <ng-transclude></ng-transclude>

    <div class="nav-btn-wrap">
      <button class="main-btn" ng-if="$ctrl.mainItem">
        <div class="icon" ng-if="$ctrl.mainItem.icon">
          <i ng-class="$ctrl.mainItem.icon"></i>
        </div>
      </button>

      <button class="active" ng-repeat="item in $ctrl.items track by $index">
        <div class="icon" ng-if="item.icon">
          <i ng-class="item.icon"></i>
        </div>
        <span ng-if="item.title">{{ item.title }}</span>
      </button>
    </div>
  </div>
  `,
  // transclude: true,
};

export default angular.module('components.abRail', [])
  .component(RailComponent.selector, RailComponent)
  .name;
